import { createSlice } from '@reduxjs/toolkit';

import type { OrganizationResponse } from './types';

export const slice = createSlice({
    initialState: {
        organizations: undefined as OrganizationResponse[] | undefined
    },

    name: 'useOrganizations',

    reducers: {
        organizations: (state, action) => {
            state.organizations = action.payload;
        }
    }
});

export default slice.reducer;
